class DeliveryWizardController {
    constructor($q, addressService, timeslotService, shopperService, loginService, fulfilmentSteps, sessionStorage, settings, fulfilmentWizardService) {
        this.$q = $q;
        this.addressService = addressService;
        this.timeslotService = timeslotService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.fulfilmentSteps = fulfilmentSteps;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.fulfilmentWizardService = fulfilmentWizardService;

        this.timeTable = undefined;
        this.sessionStorageKey = 'login:trigger';
        this.saveAddressError = null;
    }

    $onInit() {
        if (this.currentAddress) {
            this.fetchTimeslots(this.currentAddress);
        }
    }

    $onChanges(changes) {
        if (changes.isActive && changes.isActive.currentValue === false) {
            if (this.currentStep === this.fulfilmentSteps.address) {
                this.decideAddressLater();
            } else if (this.currentStep === this.fulfilmentSteps.timeslot) {
                this.decideTimeLater();
            }
        }

        if (changes.isNonServiced) {
            this.saveAddressError = changes.isNonServiced.currentValue
                ? this.settings.fulfilmentSelector.notServicedNotificationMessage
                : null;
        }
    }

    fetchTimeslots(address) {
        this.timeTable = [];
        this.fulfilmentWizardService.timeTableLoading = true;
        this.timeslotService
            .listTimeslots(address.AreaId, 'Courier', address.SuburbId, address.AddressId, this.shouldGetDynamicTimetable)
            .then((dates) => {
                this.reservedWindow = this.timeslotService.findReservedWindow(dates);
                this.timeTable = dates.length === 0 ? null : dates;
                this.fulfilmentWizardService.timeTable = dates;
                this.fulfilmentWizardService.timeTableLoading = false;
                return dates;
            });
    }

    loginToSaveAddress(loginCallback) {
        if (this.shopperService.IsGuest) {
            this.loginService.promptForLogin(this.loginService.LoginToSetDeliveryOrPickupAddressMessage, undefined, undefined, undefined, () => {
                if (this.allowDecideLater) {
                    this.sessionStorage.set(this.sessionStorageKey, 'GuestLoginToSaveAddress');
                }
                return loginCallback();
            });
        }
        return loginCallback();
    }

    saveNewManualAddressForDelivery(address) {
        return this.loginToSaveAddress(() =>
            this.addressService.saveManualAddress(address)
                .then(addressResponse => this.saveAddressForDeliveryCallback(addressResponse)));
    }

    saveNewAutoAddressForDelivery(address) {
        return this.loginToSaveAddress(() =>
            this.addressService.saveAutoAddress(address)
                .then(addressResponse => this.saveAddressForDeliveryCallback(addressResponse)));
    }

    saveAddressForDeliveryCallback(addressResponse) {
        this.saveAddressError = null;
        if (addressResponse && addressResponse.Address) {
            return this.addressSelected(addressResponse.Address);
        } else if (this.addressService.savedError && this.addressService.savedError.ErrorMessage) {
            this.saveAddressError = `${this.addressService.savedError.ErrorMessage} Alternatively you could choose pick up.`;
        }
        return this.$q.reject(this.addressService.savedError);
    }

    setDeliveryAddress(address) {
        this.addressSelected(address);
    }

    savedAddressesClicked() {
        if (this.onSavedAddressesClicked) {
            this.onSavedAddressesClicked();
        }
    }

    addressSelected(address) {
        this.saveAddressError = null;
        this.currentAddress = address;
        this.changes();

        if (this.allowDecideLater && !this.settings.fulfilmentTimetable.showTimesWhenAllowDecideLater) {
            this.decideTimeLater();
        } else {
            this.fetchTimeslots(this.currentAddress);
            this.currentStep = this.fulfilmentSteps.timeslot;
        }
    }

    decideAddressLater() {
        this.currentAddress = null;
        this.selectedDate = null;
        this.selectedTime = null;
        this.finish();
    }

    setDate(date) {
        this.selectedDate = date;
    }

    setTime(time) {
        this.selectedTime = time;
        this.finish();
    }

    decideTimeLater() {
        this.selectedDate = null;
        this.selectedTime = null;
        this.finish();
    }

    changes() {
        this.onFulfilmentChange(this.getCurrentFulfilmentInfo());
    }

    finish() {
        this.onFulfilmentSelected(this.getCurrentFulfilmentInfo());
    }

    getCurrentFulfilmentInfo() {
        return {
            fulfilmentInfo: {
                address: this.currentAddress,
                fulfilmentMethod: 'Courier', // matches the enum in the api
                fulfilmentWindow: {
                    date: this.selectedDate,
                    time: this.selectedTime,
                },
            },
        };
    }
}

DeliveryWizardController.$inject = ['$q', 'AddressService', 'FulfilmentTimeslotService', 'ShopperService', 'LoginService', 'FulfilmentSteps', 'SessionStorageWrapper', 'Settings', 'FulfilmentWizardService'];

const deliveryWizardComponentDefinition = {
    controller: DeliveryWizardController,
    bindings: {
        onFulfilmentSelected: '&',
        onFulfilmentChange: '&',
        onSavedAddressesClicked: '&?',
        currentAddress: '<?',
        currentTimeslot: '<?',
        allowDecideLater: '<?',
        currentStep: '=',
        isActive: '<',
        shouldGetDynamicTimetable: '<?',
        isNewFulfilmentMethodSelector: '<?',
        isNonServiced: '<',
    },
    template: require('./delivery-wizard.component.html').trim(),
};

module.exports = {
    DeliveryWizardController,
    deliveryWizardComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/delivery/delivery-wizard.component.js